import { i18n } from "./i18n/i18n.js";
const t = i18n.translate;
console.log("i18n init");

export default t;
